/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PaymentMethodDto } from './PaymentMethodDto';
import {
    PaymentMethodDtoFromJSON,
    PaymentMethodDtoFromJSONTyped,
    PaymentMethodDtoToJSON,
} from './PaymentMethodDto';

/**
 * 
 * @export
 * @interface RetryPaymentDto
 */
export interface RetryPaymentDto {
    /**
     * 
     * @type {PaymentMethodDto}
     * @memberof RetryPaymentDto
     */
    paymentMethod: PaymentMethodDto;
}

/**
 * Check if a given object implements the RetryPaymentDto interface.
 */
export function instanceOfRetryPaymentDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "paymentMethod" in value;

    return isInstance;
}

export function RetryPaymentDtoFromJSON(json: any): RetryPaymentDto {
    return RetryPaymentDtoFromJSONTyped(json, false);
}

export function RetryPaymentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RetryPaymentDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'paymentMethod': PaymentMethodDtoFromJSON(json['paymentMethod']),
    };
}

export function RetryPaymentDtoToJSON(value?: RetryPaymentDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'paymentMethod': PaymentMethodDtoToJSON(value.paymentMethod),
    };
}

